import { useState, useEffect, useRef, useCallback } from 'react';

const useQRCodeTimer = (initialMinutes: number) => {
  const [time, setTime] = useState(initialMinutes * 60);
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const tick = useCallback(() => {
    setTime(prevTime => {
      if (prevTime <= 1) {
        clearInterval(intervalRef.current!);
        setIsRunning(false);
        return 0;
      }
      return prevTime - 1;
    });
  }, []);

  const start = useCallback(() => {
    if (!isRunning) {
      setIsRunning(true);
      intervalRef.current = setInterval(tick, 1000);
    }
  }, [isRunning, tick]);

  const stop = useCallback(() => {
    if (isRunning) {
      clearInterval(intervalRef.current!);
      setIsRunning(false);
    }
  }, [isRunning]);

  const reset = useCallback(() => {
    clearInterval(intervalRef.current!);
    setTime(initialMinutes * 60);
    setIsRunning(false);
  }, [initialMinutes]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return {
    rawTime: time,
    start,
    stop,
    reset,
    isRunning,
  };
};

export default useQRCodeTimer;